<div class="editor-wrapper h-100" style="max-height: 100%">
  <div class="editor-toolbar">
    @if (isReadOnly) {
      <button class="bm-btn" (click)="startEdit()"><fa-icon [icon]="faEdit"></fa-icon> Bearbeiten</button>
    }
    @if (!isReadOnly) {
      <button class="bm-btn bm-btn-primary" (click)="save()">
        <fa-icon [icon]="faSave"></fa-icon>
      </button>
      <button class="bm-btn bm-btn-error" (click)="cancelEdit()">Abbrechen</button>
    }
  </div>

  <div #editorContainer class="editor-content editorjs"></div>
</div>
